import apiClient from "./ApiInterceptor";

export const fetchAchievementProgressForUser = async (userId) => {
    try {
        const response = await apiClient.get(`/achievements/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error('AchievementsApi - fetchAchievementProgressForUser, Error fetching achievement progress:', error);
    }
};

export const fetchAchievementProgressByName = async (achievement_name) => {
    try {
        const response = await apiClient.get(`/achievements/${achievement_name}`);
        return response.data;
    } catch (error) {
        console.error('AchievementsApi - fetchAchievementProgressByName, Error fetching achievement progress:', error);
    }
};

export const fetchAchievementAnimationsForUser = async (userId) => {
    try {
        const response = await apiClient.get(`/achievements/animations/user/${userId}`);
        return response.data;
    } catch (error) {
        console.error('AchievementsApi - fetchAchievementAnimationsForUser, Error fetching achievement animations:', error);
    }
}

export const markAchievementsAsSeen = async ({ user_id, animation_ids }) => {
    try {
        const response = await apiClient.post('/achievements/animations/seen', { user_id, animation_ids });
        return response.data;
    } catch (error) {
        console.error('AchievementsApi - markAchievementsAsSeen, Error marking achievement animations as seen:', error);
    }
}
